// removed by extract-text-webpack-plugin
module.exports = {"intervention-icon":"InterventionIcon__intervention-icon___1hrIj"};